import React, { useState } from 'react';
import styled from 'styled-components';
import { VehicleType } from '../../../../enums/TurnVehicleType';

type FilterListProps = {
  pickedItems: readonly (number | string | VehicleType)[];
  allItems: readonly (number | string | VehicleType)[];
  handleChange: (item: any) => void;
  countByItem: (item: any) => number;
};

const FilterList: React.FC<FilterListProps> = ({
  pickedItems,
  allItems,
  handleChange,
  countByItem,
}) => {
  const [searchText, setSearchText] = useState('');

  const generateOptions = () => {
    return [...allItems]
      .filter((item) => countByItem(item) > 0)
      .filter((item) => {
        if (typeof item === 'string') {
          return item.toLowerCase().includes(searchText.toLowerCase());
        }
        return item.toString().toLowerCase().includes(searchText.toLowerCase());
      });
  };

  const options = generateOptions();

  return (
    <div data-testid='filter-list'>
      <SearchContainer>
        <Search
          type='text'
          placeholder={`Filter...`}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </SearchContainer>
      {options.map((item) => (
        <ListItem key={item}>
          <Checkbox
            id={`${item}`}
            type='checkbox'
            checked={pickedItems.includes(item)}
            onChange={() => handleChange(item)}
          />
          <LabelContainer data-testid='label-container' onClick={() => handleChange(item)}>
            <label>{item}</label>
            <label style={{ width: '20%', textAlign: 'end' }}>{countByItem(item)}</label>
          </LabelContainer>
        </ListItem>
      ))}
    </div>
  );
};
const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  label:nth-child(2) {
    font-weight: 400;
    color: #969696;
  }
`;
const Checkbox = styled.input`
  width: 14px;
  height: 14px;
  margin: 3px 5px 0 0 !important;
  border: 1px solid #a8a8a8;
  line-height: 0.9;
  text-align: center;
  background: #fff;
  align-self: flex-start;
`;
const ListItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #fff;
  border-bottom: 1px solid #3e3e3e;
  position: relative;
  margin-bottom: 0;
  width: 100%;
  cursor: pointer;
  word-break: break-word;
  z-index: 0;
  padding: 6px 10px 6px 20px;

  label {
    font-weight: 400;
    color: #fff;
    font-size: 14px;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  border-bottom: 0;
  padding: 10px 7px 0;

  &::before {
    position: absolute;
    font-family: icomoon;
    content: '\\E606';
    top: 12px;
    left: 15px;
    color: #454545;
  }
`;
const Search = styled.input`
  width: 100%;
  color: #eee;
  font-size: 12px;
  height: 26px;
  box-sizing: border-box;
  border: 1px solid #222;
  border-bottom-color: #3e3e3e;
  letter-spacing: 0.05em;
  padding: 0 19px 0 25px;
  background: #2b2b2b;
  outline: none;
  border-radius: 5px;
  transition: all 0.1s ease-in-out;

  &:focus {
    color: #2b2b2b;
    background-color: #ededed;
  }
`;

export default FilterList;
